<app-page-title [title]="!id ? 'Cadastrar criança' : 'Editar criançã'"></app-page-title>
<div class="form-container">
  <form class="form" [formGroup]="form">
    <br />
    <label for="name">Nome da Criança</label>
    <mat-form-field class="example-full-width" appearance="outline">
      <input matInput value="Sushi" formControlName="name" />
      <mat-error *ngIf="form.controls.name.errors"> Tamanho minimo 5 letras </mat-error>
    </mat-form-field>

    <br />
    <label for="birth_date">Data de nascimento</label>
    <mat-form-field class="example-full-width" appearance="outline">
      <input type="date" matInput formControlName="birth_date" placeholder="birth_date" />
      <mat-error *ngIf="form.controls.name.errors"> Selecione a data de nascimento </mat-error>
    </mat-form-field>

    <br />
    <label>Sexo</label>
    <br />

    <label for="masculino" style="font-weight: 400">Masculino</label>
    <input type="radio" name="gender" formControlName="gender" value="M" id="masculino" />
    <label for="feminino" style="font-weight: 400">Femino</label>
    <input type="radio" name="gender" formControlName="gender" value="F" id="feminino" />

    <br />
    <br />
    <label for="obs">Observações</label>
    <br />
    <mat-form-field class="example-full-width" appearance="outline">
      <input matInput type="text" name="obs" placeholder="doenças... alergias... " />
    </mat-form-field>

    <h1 style="font-weight: 800; align-self: center">Filiação</h1>

    <br />
    <div class="space-between">
      <label for="name">Pai</label>
      <mat-slide-toggle color="blue" checked="true" #fatherMember [formControl]="fatherIsMember"
        >é membro cadastrado</mat-slide-toggle
      >
    </div>

    <mat-form-field *ngIf="!fatherMember.checked" class="example-full-width" appearance="outline">
      <input matInput type="text" name="obs" placeholder="Nome completo do pai" formControlName="father_name" />
      <mat-error *ngIf="form.controls.father_name.errors"> Digite o nome do pai</mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="fatherMember.checked" class="example-full-width" appearance="outline">
      <input
        type="text"
        placeholder="Digite o nome do pai para buscar"
        aria-label="Number"
        matInput
        #fatherSearch
        formControlName="father_name"
        [matAutocomplete]="autoFather"
      />
      <mat-error *ngIf="form.controls.father_name.errors"> Escreva o nome do pai</mat-error>
      <mat-error *ngIf="form.controls.father_id.errors && fatherIsMember"> Selecione o pai na lista</mat-error>
    </mat-form-field>

    <mat-autocomplete autoActiveFirstOption #autoFather="matAutocomplete">
      <mat-option *ngFor="let father of fathers" [value]="father.name" (click)="setId(father.id, 'father_id')">
        {{ father.name }}
      </mat-option>
    </mat-autocomplete>

    <br />

    <br />
    <div class="space-between">
      <label for="name">Mãe</label>
      <mat-slide-toggle color="blue" checked="true" #motherIsMemberCheck [formControl]="motherIsMember"
        >é membro cadastrado</mat-slide-toggle
      >
    </div>

    <mat-form-field *ngIf="!motherIsMemberCheck.checked" class="example-full-width" appearance="outline">
      <input
        matInput
        type="text"
        name="obs"
        placeholder="Digite o nome completo da Mãe"
        formControlName="mother_name"
      />
    </mat-form-field>

    <mat-form-field *ngIf="motherIsMemberCheck.checked" class="example-full-width" appearance="outline">
      <input
        type="text"
        placeholder="Digite o nome para  do mãe buscar"
        aria-label="Number"
        matInput
        #fatherSearch
        formControlName="mother_name"
        [matAutocomplete]="autoMother"
      />
      <mat-error *ngIf="form.controls.mother_name.errors"> Selecione o pai</mat-error>
    </mat-form-field>

    <mat-autocomplete autoActiveFirstOption #autoMother="matAutocomplete">
      <mat-option *ngFor="let mother of mothers" [value]="mother.name" (click)="setId(mother.id, 'mother_id')">
        {{ mother.name }}
      </mat-option>
    </mat-autocomplete>

    <br />
    <label for="phone">Telefone(do pai ou da mãe)</label>
    <mat-form-field class="example-full-width" appearance="outline">
      <input matInput type="text" id="phone" placeholder="Telefone" formControlName="phone" appPhoneMask />
    </mat-form-field>

    <button class="btn-save" *ngIf="!id" (click)="save()">Salvar</button>
    <button class="btn-save" *ngIf="id" (click)="update()">Salvar</button>
    <button class="btn-cancel">Cancelar</button>
  </form>
</div>
